import { createContext, useContext, type ReactNode } from 'react';
import type { PlatformCapabilities } from './types';

const PlatformContext = createContext<PlatformCapabilities | null>(null);

export function PlatformProvider({
  platform,
  children,
}: {
  platform: PlatformCapabilities;
  children: ReactNode;
}) {
  return (
    <PlatformContext.Provider value={platform}>
      {children}
    </PlatformContext.Provider>
  );
}

export function usePlatform(): PlatformCapabilities {
  const platform = useContext(PlatformContext);
  if (!platform) {
    throw new Error('usePlatform must be used within a PlatformProvider');
  }
  return platform;
}
